const BADGE_ICONS = {
  blue: require("./blue.json"),
  gold: require("./gold.json"),
  silver: require("./silver.json"),
  bronze: require("./bronze.json"),
};

module.exports = BADGE_ICONS;
